import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-intro-card',
	templateUrl: 'intro-card.component.html',
	styleUrls: ['intro-card.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class IntroCardComponent {
	@Input()
	icon: string | undefined = undefined;

	@Input()
	heading: string | undefined = undefined;
}
